<template>
    <div ref="node">
        <div>{{ name }}</div>
        <div class="node-description">{{ description }}</div>
    </div>
</template>

<script>

export default {
  data() {
    return {
      nodeId: null,
      name: null,
      id: null,
      description: null
    }
  },
  async mounted() {
    await this.$nextTick()
    this.nodeId = this.$refs.node.parentElement.parentElement.id
    const dataNode = this.$df.getNodeFromId(this.nodeId.slice(5))
    this.id = dataNode.data.id
    this.name = dataNode.data.name
    this.description = dataNode.data.description
  },
  methods: {

  }
}
</script>
<style>
</style>
